import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { name: "首页", path: "/" },
  { name: "分类浏览", path: "/category/all" },
  { name: "影视资讯", path: "/category/all" },
  { name: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500">
              <i className="ri-play-fill text-background-50 text-xl"></i>
            </div>
            <span
              className={`text-lg font-semibold whitespace-nowrap transition-colors duration-300 ${
                scrolled ? "text-foreground-950" : "text-white"
              }`}
              style={{ fontFamily: "var(--font-heading)" }}
            >
              91看网页版
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:text-primary-500 ${
                  location.pathname === link.path
                    ? "text-primary-500"
                    : scrolled
                    ? "text-foreground-700"
                    : "text-white/85"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                scrolled
                  ? "border border-background-300 text-foreground-700 hover:bg-background-100"
                  : "border border-white/30 text-white hover:bg-white/10"
              }`}
            >
              登录
            </button>
            <Link
              to="/category/all"
              className="px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200"
            >
              立即观看
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-xl transition-colors duration-300 ${
                scrolled ? "text-foreground-950" : "text-white"
              } ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? "bg-primary-50 text-primary-600"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="flex gap-3 mt-3 px-4">
              <button className="flex-1 py-2.5 rounded-full text-sm font-medium border border-background-300 text-foreground-700 hover:bg-background-100 transition-colors">
                登录
              </button>
              <Link
                to="/category/all"
                className="flex-1 py-2.5 rounded-full text-sm font-medium text-center bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
              >
                立即观看
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}